module.exports = __webpack_public_path__ + "static/media/reopen.dba5014e.svg";